<script setup>
const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (value) => {
      return ['search', 'sign-in'].includes(value)
    },
  },
});
</script>

<template>
  <svg
    width="268"
    height="268"
    viewBox="0 0 268 268"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M99.792 247.242V210.872C99.792 210.456 100.117 210.118 100.517 210.118H106.954C107.385 210.118 107.722 210.501 107.676 210.947C107.154 215.987 104.29 242.461 101.136 247.643C100.744 248.286 99.792 248.003 99.792 247.242L99.792 247.242Z"
      fill="#693118"
    />
    <path
      d="M128.178 246.663L123.222 209.225C123.163 208.79 122.8 208.487 122.412 208.548L116.174 209.53C115.756 209.596 115.484 210.047 115.592 210.506C116.813 215.686 123.346 242.879 127.138 247.806C127.609 248.418 128.286 247.457 128.178 246.663Z"
      fill="#693118"
    />
    <path
      d="M203.717 87.3337L227.978 88.7324L212.022 93.4495L227.959 101.527L203.689 106.525L203.717 87.3337Z"
      fill="#DB8827"
    />
    <path
      d="M24.0859 104.027C24.0859 104.027 17.4726 227.289 120.318 212.75C147.343 208.929 164.538 197.085 172.852 189.362C181.165 181.64 208.237 145.378 208.781 102.788C209.326 60.1989 196.26 51.6908 179.89 49.0305C163.52 46.3703 150.669 65.453 148.904 74.2393C147.138 83.0256 142.805 128.354 112.759 133.222C70.3047 140.101 24.0859 104.027 24.0859 104.027Z"
      fill="#FAA723"
    />
    <path
      d="M168.804 88.4747C168.977 89.538 169.493 92.7278 173.11 95.4153C176.727 98.1027 180.861 97.4328 181.895 97.2653C182.928 97.0979 188.613 92.9032 188.097 89.7133C187.581 86.5235 187.926 82.1029 182.242 79.7504C176.558 77.3979 173.801 80.0269 171.906 81.4251C170.011 82.8233 168.46 86.3481 168.804 88.4747Z"
      fill="white"
    />
    <path
      d="M180.177 92.5795C177.556 93.0041 175.088 91.223 174.664 88.6012C174.239 85.9794 176.02 83.5097 178.64 83.0851C181.261 82.6605 183.729 84.4417 184.154 87.0635C184.578 89.6853 182.798 92.1549 180.177 92.5795Z"
      fill="black"
    />
    <path
      v-if="type === 'search'"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M199.084 118.854C223.89 118.854 244 98.7338 244 73.9145C244 49.0951 223.89 28.9751 199.084 28.9751C174.277 28.9751 154.167 49.0951 154.167 73.9145C154.167 98.7338 174.277 118.854 199.084 118.854ZM198.696 110.331C219.012 110.331 235.482 93.8533 235.482 73.5271C235.482 53.2009 219.012 36.7233 198.696 36.7233C178.381 36.7233 161.911 53.2009 161.911 73.5271C161.911 93.8533 178.381 110.331 198.696 110.331Z"
      fill="#999999"
    />
    <ellipse
      v-if="type === 'search'"
      cx="198.696"
      cy="73.5269"
      rx="36.7852"
      ry="36.8038"
      fill="#236439"
      fill-opacity="0.23"
    />
    <path
      v-if="type === 'search'"
      d="M180.497 48.7326C189.403 39.8228 216.939 43.3951 218.444 53.7687C218.725 55.7057 213.952 56.8679 212.248 54.9308C203.73 45.2462 195.761 43.3251 180.497 48.7326Z"
      fill="#CCDBD1"
    />
    <ellipse
      v-if="type === 'search'"
      cx="3.48573"
      cy="4.26162"
      rx="3.48573"
      ry="4.26162"
      transform="matrix(0.911277 -0.411794 0.411448 0.911433 219.993 61.2886)"
      fill="#CCDBD1"
    />
    <path
      v-if="type === 'search'"
      d="M179.06 119.004C175.181 126.636 173.922 130.997 171.254 138.738L179.374 142.25C182.572 134.212 184.436 129.735 186.797 121.353C188.61 122.101 189.652 122.472 191.827 122.531C193.283 121.273 193.569 120.313 193.389 118.274L175.984 112.021C174.005 113.107 173.842 114.046 174.036 115.889C175.16 117.225 176.163 117.921 179.06 119.004Z"
      fill="#CCCCCC"
    />
    <rect
      v-if="type === 'search'"
      width="12.0232"
      height="49.5306"
      rx="6.01162"
      transform="matrix(0.93033 0.366724 -0.366403 0.930456 170.443 135.878)"
      fill="#8C6239"
    />
    <path
      d="M190.425 152.937C190.425 152.937 181.36 149.098 169.904 143.524C158.447 137.951 142.422 117.195 121.518 118.459C100.614 119.724 92.5061 134.836 92.1234 145.513C91.7408 156.189 100.472 170.377 117.715 173.21C150.243 178.554 190.425 152.937 190.425 152.937Z"
      fill="#FFC82B"
    />
    <path
      v-if="type === 'sign-in'"
      d="M208.024 37.4159C205.153 47.8822 203.912 53.5966 202.614 63.4012C218.651 66.0689 225.812 67.9853 232.169 72.8735C187.567 66.6878 173.406 66.2048 152.108 66.4327C151.413 53.1199 150.725 45.8295 149.153 33.0296C169.387 27.0632 192.673 27.091 208.024 37.4159Z"
      fill="#673A0F"
    />
    <path
      v-if="type === 'sign-in'"
      d="M204.037 58.0886C188.443 54.6669 152.304 53.8448 150.22 56.0917C149.649 57.8959 149.643 58.9412 150.988 60.956C170.83 61.4843 182.091 61.8516 203.226 63.0476C203.835 61.1486 203.956 60.0554 204.037 58.0886Z"
      fill="#E34B0C"
    />
    <path
      v-if="type === 'sign-in'"
      d="M168.876 163.991C174.198 164.288 179.18 160.834 180.614 155.482C182.258 149.347 178.617 143.041 172.482 141.397C170.394 140.838 168.285 140.891 166.348 141.446C163.767 139.729 160.986 137.513 158.001 135.135C157.551 134.776 157.096 134.413 156.637 134.048C161.89 130.39 168.661 128.986 175.329 130.772C187.315 133.984 194.435 146.29 191.253 158.277L223.601 176.732C224.561 177.28 224.895 178.501 224.347 179.461L219.887 187.278C219.34 188.237 218.119 188.571 217.159 188.024L213.654 186.024L210.199 192.08C209.652 193.039 208.43 193.373 207.471 192.826L198.785 187.87C197.825 187.323 197.491 186.102 198.039 185.142L201.494 179.086L184.427 169.35C178.962 174.181 171.256 176.268 163.682 174.239C160.164 173.296 157.065 171.57 154.522 169.298C159.636 167.711 164.488 165.863 168.876 163.991Z"
      fill="#874110"
    />
  </svg>
</template>
